import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-modal-manual-debt',
  templateUrl: './modal-manual-debt.component.html',
  styleUrls: ['./modal-manual-debt.component.scss']
})
export class ModalManualDebtComponent implements OnInit {

  comertialAgreements: any = [];
  comertialAgreementProducts: any = [];
  productBusinessUnits: any = {};
  filterTerm: string = '';
  sending: boolean = false;

  debtForm: FormGroup = this.fb.group({
    commercial_agreement_id: new FormControl('', Validators.required),
    date: new FormControl('', Validators.required),
    max_payment_date: new FormControl('', Validators.required),
    status: new FormControl('active', Validators.required),
    concept: new FormControl(''),
    items: this.fb.array([])
  });

  get items(): FormArray {
    return this.debtForm.get('items') as FormArray;
  }

  constructor(
    private uService: UtilsService,
    private toast: ToastrService,
    private mService: MainService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalManualDebtComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.getComertialAgreements();
    this.getProductBusinessUnits();

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    this.debtForm.get('date')!.setValue(yesterday.toISOString().slice(0, 10));
  }

  getComertialAgreements() {
    this.mService.get_request('commercial-agreements/list')
    .subscribe((resp: any) => {
      if (resp.status) {
        this.comertialAgreements = resp.items;
        this.setBusinessUnitLabels();
      } else {
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if (resp.message.includes('expirado')) {
          this.uService.logOut$.next(true);
        }
      }
    });
  }

  getProductBusinessUnits() {
    this.mService.get_request('product/list')
    .subscribe((resp: any) => {
      if (resp.status) {
        resp.items.forEach((product: any) => {
          this.productBusinessUnits[product.id] = product.business_unit_name;
        });
        this.setBusinessUnitLabels();
      }
    });
  }

  setBusinessUnitLabels() {
    this.comertialAgreements.forEach((agreement: any) => {
      var businessUnitNames = new Set();
      (agreement.commercial_agreements_products || []).forEach((product: any) => {
        var businessUnitName = this.productBusinessUnits[product.id];
        if (businessUnitName) {
          businessUnitNames.add(businessUnitName);
        }
      });
      agreement.businessUnitLabel = Array.from(businessUnitNames).join(', ');
    });
  }

  changeComertialAgreement(event: any) {
    this.comertialAgreementProducts = [];
    this.items.clear();

    this.mService.get_request('commercial-agreements-product/list', { commercial_agreement_id: event.value })
    .subscribe((resp: any) => {
      if (resp.status) {
        this.comertialAgreementProducts = resp.items;
      } else {
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if (resp.message.includes('expirado')) {
          this.uService.logOut$.next(true);
        }
      }
    });
  }

  addItem() {
    if (this.comertialAgreementProducts.length === 0) {
      this.toast.error('Seleccione un acuerdo comercial con productos disponibles', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      return;
    }
    this.items.push(this.fb.group({
      commercial_agreement_products_id: new FormControl('', Validators.required),
      debt_amount: new FormControl('', Validators.required)
    }));
  }

  removeItem(index: number) {
    this.items.removeAt(index);
  }

  submit() {
    if (this.debtForm.get('commercial_agreement_id')!.invalid ||
        this.debtForm.get('date')!.invalid ||
        this.debtForm.get('max_payment_date')!.invalid ||
        this.debtForm.get('status')!.invalid) {
      this.uService.validateForm(this.debtForm);
      return;
    }

    if (this.items.length === 0) {
      this.toast.error('Agregue al menos un producto para generar la deuda', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      return;
    }

    if (this.items.invalid) {
      this.items.markAllAsTouched();
      this.toast.error('Complete los datos de los productos agregados', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      return;
    }

    this.sending = true;

    var body = {
      commercial_agreement_id: this.debtForm.get('commercial_agreement_id')!.value,
      date: this.debtForm.get('date')!.value,
      max_payment_date: this.debtForm.get('max_payment_date')!.value,
      status: this.debtForm.get('status')!.value,
      concept: this.debtForm.get('concept')!.value,
    };

    this.mService.post_request('due-payment/create', body)
    .subscribe((resp: any) => {
      if (resp.status) {
        this.createItems(resp.item.id);
      } else {
        this.sending = false;
        if (resp?.errors != undefined) {
          resp.errors.forEach((element: any) => {
            this.toast.error(element, resp.message, {timeOut: 5000, progressBar: true, closeButton: true});
          });
        } else if (resp.message) {
          this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        }
      }
    });
  }

  createItems(due_payment_id: number) {
    var pending = this.items.length;
    var hadError = false;

    this.items.controls.forEach((itemControl) => {
      var itemBody = {
        due_payment_id: due_payment_id,
        commercial_agreement_products_id: itemControl.get('commercial_agreement_products_id')!.value,
        debt_amount: itemControl.get('debt_amount')!.value,
      };

      this.mService.post_request('due-payment-item/create', itemBody)
      .subscribe((resp: any) => {
        pending--;
        if (!resp.status) {
          hadError = true;
          if (resp.message) {
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
          }
        }

        if (pending === 0) {
          this.sending = false;
          if (!hadError) {
            this.toast.success('Deuda generada con éxito', 'Éxito', {timeOut: 5000, progressBar: true, closeButton: true});
          }
          this.dialogRef.close('reload');
        }
      });
    });
  }

  ngOnInit(): void {
  }

  dismiss() {
    this.dialogRef.close(null);
  }
}
